import type { SVGProps } from 'react';

const SvgFitWidth = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20 6c-.55 0-1 .45-1 1v4.09L16.21 8.3a.996.996 0 1 0-1.41 1.41L16.09 11H7.91L9.2 9.71A.996.996 0 1 0 7.79 8.3L5 11.09V7c0-.55-.45-1-1-1s-1 .45-1 1v10c0 .55.45 1 1 1s1-.45 1-1v-4.09l2.79 2.79c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41L7.92 13h8.17l-1.29 1.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l2.79-2.79V17c0 .55.45 1 1 1s1-.45 1-1V7c0-.55-.45-1-1-1z"
    />
  </svg>
);
export default SvgFitWidth;
